import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import './FAQSection.scss';

const FAQSection = () => {
    window.scroll(0, 0)
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            id: 1,
            question: "What services does Reachtix offer?",
            answer: "Reachtix provides performance-driven digital marketing services including SEO (AI SEO, Technical, Ecommerce & International SEO), Paid Media (PPC, Paid Social, Programmatic, Meta Advertising), Data & Analytics, Strategy & Consultancy, and Experience-led services such as CRO, Creative, Technology and Video."
        },
        {
            id: 2,
            question: "Which industries do you specialise in?",
            answer: "We work across multiple sectors, with deep experience in: • Ecommerce • Hospitality & Travel • B2B & Professional Services • SaaS • Fintech & Financial Services. Our strategies are adapted to each industry's audience, funnel, and growth stage."
        },
        {
            id: 3,
            question: "Do you work only with UK-based businesses?",
            answer: "No. While we are UK-based and UK-focused, we also work with international brands looking to scale in the UK or globally through international SEO, paid media, and market-entry strategies."
        },
        {
            id: 4,
            question: "What makes Reachtix different from other digital marketing agencies?",
            answer: "We are performance-first. That means every strategy, campaign, and creative decision is tied to measurable outcomes such as revenue, leads, and ROI — not vanity metrics. We combine data, strategy, and execution rather than treating them as separate silos."
        },
        {
            id: 5,
            question: "Do you offer customised strategies or fixed packages?",
            answer: "Both. We offer flexible engagement models — from structured packages to fully customised strategies — depending on your business goals, market, and budget."
        },
        {
            id: 6,
            question: "What is AI SEO and how is it different from traditional SEO?",
            answer: "AI SEO focuses on optimising content and structure for modern search behaviour, including AI-powered and generative search experiences. It goes beyond keywords to include semantic relevance, intent modelling, and content intelligence, helping brands stay competitive as search evolves."
        },
        {
            id: 7,
            question: "Can you manage both Paid Media and SEO together?",
            answer: "Yes — and that's often where we deliver the strongest results. By combining Paid Media insights with SEO data, we align short-term performance with long-term organic growth, improving efficiency and reducing overall acquisition costs."
        },
        {
            id: 8,
            question: "What platforms do you work with?",
            answer: "Depending on the project, we work with platforms such as: • Google Ads & Google Analytics 4 • Meta (Facebook & Instagram) Ads • Programmatic advertising platforms • Google Tag Manager • Analytics, BI and data visualisation tools. Our approach is platform-agnostic and strategy-led."
        },
        {
            id: 9,
            question: "Do you provide reporting and transparency?",
            answer: "Absolutely. We provide clear, transparent reporting focused on metrics that matter — performance, ROI, and growth indicators — not just surface-level numbers."
        },
        {
            id: 10,
            question: "What is included in a free audit?",
            answer: "A free audit typically includes a high-level review of your SEO, Paid Media, analytics setup, and digital performance, identifying key opportunities and areas for improvement. There is no obligation — it's designed to provide immediate value."
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section ">
            {/* Header */}
            <div className="text-center mb-5">
                <h2 className="title mb-3">
                    Frequently Asked Questions ?
                </h2>

            </div>
            <div className="text-center mb-5">
                <h3 className="subtitle">
                    Find answers to common questions about our services and approach
                </h3>

            </div>

            {/* FAQ Items */}
            <Row className="justify-content-center">
                <Col lg="9">
                    <div className="faq-accordion">
                        {faqs.map((faq, index) => (
                            <div
                                key={faq.id}
                                className={`faq-item ${activeIndex === index ? 'faq-active' : ''}`}
                            >
                                <button
                                    className="faq-question-btn"
                                    onClick={() => toggleFAQ(index)}
                                    aria-expanded={activeIndex === index}
                                    type="button"
                                >
                                    <div className="faq-question-content">
                                        <span className="faq-question-text">{faq.question}</span>
                                    </div>
                                    <span className="faq-toggle-icon">
                                        <svg
                                            className={`faq-icon ${activeIndex === index ? 'faq-active' : ''}`}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M6 9L12 15L18 9"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </button>
                                <div
                                    className={`faq-answer-container ${activeIndex === index ? 'faq-active' : ''}`}
                                >
                                    <div className="faq-answer">
                                        <p>{faq.answer}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>

            {/* CTA Section */}
            <Row className="mt-5">
                <Col className="text-center">
                    <div className="faq-cta-box">
                        <h3 className="faq-cta-title mb-3">Still have questions?</h3>
                        <p className="faq-cta-text mb-4">
                            Didn't find what you're looking for? Get a free audit and personalised answers from our experts.
                        </p>
                        <Button tag={Link} color='dark' size='lg' to="/contact" >
                            Contact Now !
                        </Button>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default FAQSection;